<template>
    <button
        type="button"
        :disabled="disabled"
        :class="[
            'font-semibold flex items-center focus:ring-4 rounded-lg text-sm px-5 py-2.5 text-center mr-2',
            variant === 'primary' &&
                `text-white bg-primary-500 hover:bg-primary-700 focus:ring-primary-300`,
            variant === 'destructive' &&
                `text-white bg-red-500 hover:bg-red-700 focus:ring-red-300`,
            variant === 'dismissive' &&
                `text-gray-500 bg-gray-200 hover:bg-gray-300 focus:ring-gray-200`,
            loading && 'opacity-70 cursor-progress',
            disabled && 'opacity-70 cursor-not-allowed',
        ]"
    >
        <template v-if="loading">
            <Spinner />
        </template>
        <template v-else>
            <slot></slot>
        </template>
    </button>
</template>

<script>
import { defineComponent } from "@vue/runtime-core";
import Spinner from "@/shared/Spinner.vue";

export default defineComponent({
    name: "Button",
    components: {
        Spinner,
    },
    props: {
        loading: {
            default: false,
            type: Boolean,
        },
        disabled: {
            default: false,
            type: Boolean,
        },
        variant: {
            default: "primary",
            type: String,
        },
    },
});
</script>
